export { device, size } from 'shared/lib/styles/device';
